export default class ListSubjectCtrl{

  constructor($scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $cookies, Validations){
    var subjectListVM = this
    i18nService.setCurrentLang('es')
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

    subjectListVM.highlightFilteredHeader = highlightFilteredHeader
    subjectListVM.filter = filter
    subjectListVM.singleFilter = singleFilter
    subjectListVM.confirmDisableSubject = confirmDisableSubject

    function highlightFilteredHeader( row, rowRenderIndex, col, colRenderIndex ) {
        if( col.filters[0].term ){
          return 'header-filtered';
        } else {
          return '';
        }
    };

    subjectListVM.gridListSubjects = {
      enableFiltering: true,
      columnDefs : [{
        name: 'Nombre asignatura',
        displayName: 'Nombre asignatura',
        field: 'subject_name',
        width: '35%',
        headerCellClass: subjectListVM.highlightFilteredHeader,
        enableGridMenu: false,
        enableHiding : false,
        enablePinning: false,
        enableColumnMenu: false,
        enableSorting: false,
        cellClass: 'text-xs',
        headerCellClass: 'font-normal text-xs'
      },{
        name: 'Especialización',
        displayName: 'Especialización',
        field: 'specialization_name',
        width: '25%',
        enableGridMenu: false,
        enableHiding : false,
        enablePinning: false,
        enableColumnMenu: false,
        enableSorting: false,
        cellClass: 'text-xs',
        headerCellClass: 'font-normal text-xs'
      },{
        name: 'Estado',
        displayName: 'Estado',
        field: 'subject_status_name',
        width: '20%',
        enableGridMenu: false,
        enableHiding : false,
        enablePinning: false,
        enableColumnMenu: false,
        enableSorting: false,
        cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs',
        cellTemplate: require('./listSubjectStateCell.html')
      },{
        name: 'Acciones',
        displayName: 'Acciones',
        width: '20%',
        enableGridMenu: false,
        enableFiltering: false,
        enableHiding : false,
        enablePinning: false,
        enableColumnMenu: false,
        enableSorting: false,
        cellClass: 'column-center text-xs',
        headerCellClass: 'column-center font-normal text-xs',
        cellTemplate: require('./listSubjectCell.html')
      }
    ],
        onRegisterApi: function(gridApi){
            subjectListVM.gridApi = gridApi;
                subjectListVM.gridApi.grid.registerRowsProcessor( subjectListVM.singleFilter, 200 );
            $interval( function() {
                subjectListVM.gridApi.core.handleWindowResize();
            }, 500, 10);
        },
   }


     function filter() {
      subjectListVM.gridApi.grid.refresh();
     };

     function singleFilter ( renderableRows ){
        var matcher = new RegExp(subjectListVM.listSubjectsFilter,'i');
        renderableRows.forEach( function( row ) {
          var match = false;
          ['subject_name','specialization_name','subject_status_name'].forEach(function( field ){
            if ( row.entity[field].match(matcher) ){
              match = true;
            }
          });
          if ( !match ){
            row.visible = false;
          }
        });
        return renderableRows;
     };

  	function confirmDisableSubject (row){
      let subject = row.entity
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.subject = subject
          $scope.subjectName = subject.subject_name
          $scope.close = function() {
            $mdDialog.hide();
          }
          $scope.disableSubject = function(id){
            GeneralSettingsSrv.disableSubject.disable({subjectId:id})
            .$promise.then(function(dataReturn) {
              if(dataReturn.status == true){
                row.entity.subject_status_name = "Inactivo";
                subjectListVM.gridApi.grid.refresh()
                $mdDialog.hide();
              }else{

              }
            },function(data) {

            });
          }
        }],
        template: require('./disableSubjectModal.html'),
        clickOutsideToClose:false
      });
    }


    activate()

    function activate(){
      return getSubjectList()
    }

    function getSubjectList(){
      let header = { }
      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)){
        header.userId = user.id
        header.rolId  = currentRoleId
      } 
      GeneralSettingsSrv.getSubjects.getList(header).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          subjectListVM.gridListSubjects.data = dataReturn.data
        }else{
          subjectListVM.gridListSubjects.data = []
       }
      },function(data) {
        console.log(data)
      })
    }

		

	}
}

ListSubjectCtrl.$inject = ['$scope','GeneralSettingsSrv','$mdDialog','$interval','uiGridConstants','i18nService', '$cookies', 'Validations'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/subjects/list/listSubjectCtrl.js